export default __webpack_public_path__ + "images/d3dcecf9bb2f13e920079e615bf3f1e2.svg";